const PREFIX = '@@BACKPACK';

export const UPDATE_BACKPACK = `${PREFIX}/UPDATE_BACKPACK`;
export const FETCHED_BACKPACK = `${PREFIX}/FETCHED_BACKPACK`;
export const DELETE_BACKPACK = `${PREFIX}/DELETE_BACKPACK`;
export const START_LOADING_BACKPACK = `${PREFIX}/START_LOADING_BACKPACK`;
export const END_LOADING_BACKPACK = `${PREFIX}/END_LOADING_BACKPACK`;
export const CREATE_BACKPACK = `${PREFIX}/CREATE_BACKPACK`;
